import React, { Component } from "react";
import { number, string, array } from "prop-types";
import ReactHighstock from "react-highcharts/ReactHighstock.src";

import "./chart.css";
import chartConfig from "./chart.config";

class Chart extends Component {
  static propTypes = {
    chartWidth: number.isRequired,
    chartHeight: number.isRequired,
    series: array.isRequired,
    chartTitle: string.isRequired,
    chartSubTitle: string,
    yAxisLabel: string,
    xAxisLabel:string,
  };

  render() {
    const {
      chartWidth,
      chartHeight,
      series,
      chartTitle,
      chartSubTitle,
      yAxisLabel,
      xAxisLabel,
    } = this.props;

    const chartData = {
      series: series,
      chartTitle,
      chartSubTitle,
      chartWidth,
      chartHeight,
      yAxisLabel,
      xAxisLabel,
    };

    return (
      <div className="cp-chart">
        <ReactHighstock config={chartConfig(chartData)} />
      </div>
    );
  }
}

export default Chart;



// WEBPACK FOOTER //
// ./src/views/reports/report_chart/chart/Chart.jsx